export default {
  name: 'prodify',
  component() {
      return {
        el: '',
        pickerType: '',
        selectors: '',
        textStrings: '',
        currentVariant: '',
        optionContainers: '',
        options: '',
        variantData: '',
        embossing: {
          enabled: false,
          name: '',
          id: '',
          lineItemId: '',
        },
        attributes: {
          invoice: '',
          wrapping: false,
          invoice: false,
        },
        // quantityIncrementButton: '',
        // quantityDecrementButton: '',
        // quantityPresentationInput: '',
        // quantityHiddenInput: '',

        init() {
          if (this.$root.dataset.embossing !== undefined) return;

          this.el = this.$root;
          this.pickerType = this.el.dataset.prodify
      
          this.selectors = {
            priceContainer: '[data-prodify-price-container]',
            mediaContainer: '[data-prodify-media-container]',
            variantsJson: '[data-prodify-variants-json]',
            optionContainer: '[data-prodify-option-container]',
            productForm: '[data-prodify-product-form]',
            // quantityIncrement: '[data-prodify-quantity-increment]',
            // quantityDecrement: '[data-prodify-quantity-decrement]',
            // quantityPresentation: '[data-prodify-quantity-presentation]',
          }
      
          this.textStrings = {
            addToCart: window.variantStrings.addToCart,
            unavailableVariantValueLabel: window.variantStrings.unavailable_with_option,
            soldOutVariantValueLabel: window.variantStrings.soldout_with_option,
            addButtonTextUnavailable: window.variantStrings.unavailable,
          }
      
          // this.quantityIncrementButton = this.el.querySelector(this.selectors.quantityIncrement)
          // this.quantityDecrementButton = this.el.querySelector(this.selectors.quantityDecrement)
          // this.quantityPresentationInput = this.el.querySelector(this.selectors.quantityPresentation)
          // this.quantityHiddenInput = this.el.querySelector('input[name="quantity"]')
      
          this.initEventListeners()
        },
      
        initEventListeners() {
          // this.el.addEventListener('change', (e) => {
          //   this.onVariantChange(e);
          // });
      
          // if (
          //   this.quantityIncrementButton &&
          //   this.quantityDecrementButton &&
          //   this.quantityPresentationInput
          // ) {
          //   this.quantityIncrementButton.addEventListener('click', () => {
          //     this.updateQuantity('up')
          //   })
      
          //   this.quantityDecrementButton.addEventListener('click', () => {
          //     this.updateQuantity('down')
          //   })
          // }

          this.onVariantChange()
          
          document.addEventListener("liquid-ajax-cart:request-end", (event) => {
            const { requestState, cart, previousCart, sections } = event.detail;

            if (requestState.requestType === 'add') {
              console.log(requestState.responseData.body.properties);
              if (requestState.responseData.body.properties !== undefined && requestState.responseData.body.properties.embossing != '') {
                this.addEmbossing();
              }
            } 
          });

          window.addEventListener('remove_embossing', () => {
            this.removeEmbossing();
          });
          window.addEventListener('remove_item', (event) => {
            this.removeItem(event.detail.id, event.detail.qty);
          });
          window.addEventListener('add_item', (event) => {
            this.addItem(event.detail.id, event.detail.qty);
          });

          // this.updateCurrentVariant()

        },

        onVariantChange() {
          this.updateCurrentOptions()
          this.updateCurrentVariant()
          this.compareInputValues()

          // this.updateAddButtonDom(true, '', false)
          // this.setOptionSelected(this.$el)
          
          if (!this.currentVariant) {
            // this.updateAddButtonDom(true, this.textStrings.addButtonTextUnavailable, true)
          } else {
            this.updateURL()
            this.updateVariantIdInput()
            // this.swapProductInfo()
          }
        },
      
        updateCurrentVariant() {
          const variants = this.getVariantData();
          const matchingVariant = variants.find(variant => {
            return variant.options.every((option, index) => {
              return this.options[index] === option;
            });
          });
          this.currentVariant = matchingVariant;
          // console.log(this.currentVariant);
        },
      
        // updateQuantity(stepDirection) {
        //   const previousQuantity = parseInt(this.quantityPresentationInput.value)
      
        //   if (stepDirection == 'up') {
        //     this.quantityHiddenInput.value = this.quantityPresentationInput.value = previousQuantity + 1
        //   } else {
        //     this.quantityHiddenInput.value = this.quantityPresentationInput.value = Math.max(1, previousQuantity - 1)
        //   }
        // },
      
        updateCurrentOptions() {
          if (this.pickerType == 'select') {
            this.options = Array.from(this.el.querySelectorAll('select'), (select) => select.value)
            return
          }
      
          this.optionContainers = Array.from(this.el.querySelectorAll(this.selectors.optionContainer))
          // console.log(this.optionContainers);

          this.options = this.optionContainers.map((optionContainer) => {
            const option = Array.from(optionContainer.querySelectorAll('input')).find((radio) => radio.checked);
            return option.value;
            // if (option === undefined) {
            //   const option2 = optionContainer.querySelector('input[checked]');
            //   console.log(option2);
            //   option2.checked = true;
            //   return option2.value;
            // } else {
            //   return option.value;
            // }
          })   
        },
      
        updateVariantIdInput() {
          const productForms = this.$root.querySelectorAll(this.selectors.productForm)
          // console.log(productForms);
          productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]')
            input.value = this.currentVariant.id
            // input.dispatchEvent(new Event('change', { bubbles: true }));
          })
        },
      
        updateURL() {
          if (!this.currentVariant || this.el.dataset.updateUrl === 'false') return
          window.history.replaceState({}, '', `${this.el.dataset.url}?variant=${this.currentVariant.id}`)
        },
      
        // updateAddButtonDom(disable = true, text, modifyClass = true) {
        //   const productForm = this.$root.querySelector(this.selectors.productForm)
        //   if (!productForm) return
        //   const addButton = productForm.querySelector('[name="add"]')
        //   const addButtonText = productForm.querySelector('[name="add"] > span')
        //   if (!addButton) return
      
        //   if (disable) {
        //     addButton.setAttribute('disabled', 'disabled')
        //     if (text) addButtonText.textContent = text
        //   } else {
        //     addButton.removeAttribute('disabled')
        //     addButtonText.textContent = this.textStrings.addButtonTextUnavailable
        //   }
      
        //   if (!modifyClass) return
      
        //   if (disable) {
        //     addButton.classList.add('disabled')
        //   } else {
        //     addButton.classList.remove('disabled')
        //   }
        // },
            
        // setOptionSelected(select) {
        //   if (this.pickerType == 'select') {
        //     const options = Array.from(select.querySelectorAll('option'))
        //     const currentValue = select.value
      
        //     options.forEach((option) => {
        //       if (option.value === currentValue) {
        //         option.setAttribute('selected', 'selected')
        //       } else {
        //         option.removeAttribute('selected')
        //       }
        //     })
        //   }
        // },
      
        compareInputValues() {
          const variantsMatchingOptionOneSelected = this.variantData.filter(
            // Grab the first checked input and compare it to the variant option1
            // return an array of variants where the option1 matches the checked input
            (variant) => this.el.querySelector(':checked').value === variant.option1
          )
      
          const inputWrappers = [...this.el.querySelectorAll(this.selectors.optionContainer)]
          inputWrappers.forEach((option, index) => {
            if (index === 0) return
            const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
            const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value
            const availableOptionInputsValues = variantsMatchingOptionOneSelected
              .filter(
                // 
                (variant) => variant.available && variant[`option${index}`] === previousOptionSelected
              )
              .map((variantOption) => variantOption[`option${index + 1}`])
      
            const existingOptionInputsValues = variantsMatchingOptionOneSelected
              .filter(
                // 
                (variant) => variant[`option${index}`] === previousOptionSelected
              )
              .map((variantOption) => variantOption[`option${index + 1}`])
      
            this.setInputAvailability(optionInputs, availableOptionInputsValues, existingOptionInputsValues)
          })
        },
      
        setInputAvailability(optionInputs, availableOptionInputValues, existingOptionInputsValues) {
          optionInputs.forEach((input) => {
            if (availableOptionInputValues.includes(input.getAttribute('value'))) {
              if (this.pickerType == 'select') {
                input.innerText = input.getAttribute('value')
                return
              }
              input.classList.remove('disabled')
            } else {
              if (existingOptionInputsValues.includes(input.getAttribute('value'))) {
                if (this.pickerType == 'select') {
                  input.innerText = this.textStrings.soldOutVariantValueLabel.replace(
                    '[value]',
                    input.getAttribute('value')
                  )
                  return
                }
                input.classList.add('disabled')
              } else {
                if (this.pickerType == 'select') {
                  input.innerText = this.textStrings.unavailableVariantValueLabel.replace(
                    '[value]',
                    input.getAttribute('value')
                  )
                  return
                }
                input.classList.add('disabled')
              }
            }
          })
        },

        zoom(e) {
            const zoomer = this.$el;
            let offsetX;
            let offsetY;

            this.$event.offsetX ? offsetX = this.$event.offsetX : offsetX = this.$event.touches[0].pageX;
            this.$event.offsetY ? offsetY = this.$event.offsetY : offsetX = this.$event.touches[0].pageX;
            const x = offsetX / zoomer.offsetWidth*100;
            const y = offsetY/zoomer.offsetHeight*100;

            zoomer.style.backgroundPosition = x + '% ' + y + '%';
        },

        checkEmbossing(type) {
          if (this.embossing.name == '' || this.embossing.name == ' ' || this.embossing.name == '  ' || this.embossing.name.length > 5 || this.embossing.name.includes('&')) {
            this.$refs.embossinginput.classList.add('has-error');
            this.embossing.enabled = false;
          } else {
            this.$refs.embossinginput.classList.remove('has-error');
            this.embossing.enabled = true;
            this.$store.global.popup = false;
            // this.$store.global.popup_cart = false;

            if (type === 'submit') {
              this.updateEmbossing();
            }
          }
        },
        
        updateEmbossing() {
          const body = {
            id: this.embossing.lineItemId,
            properties: {
              embossing: this.embossing.name
            }
          }
          
          const options = {
            firstCallback: function(requestState) {
            },
            lastCallback: function(requestState) {
            },
            info: {
              myParameter: 'value'
            },
            important: false
          }
          liquidAjaxCart.change(body, options);
          
          this.addEmbossing();
          this.$store.global.popup_cart = false;
        },

        addEmbossing() {
          const body = {
            items: [
              {
                id: this.embossing.id,
                quantity: 1
              }
            ]  
          }
          
          const options = {
            firstCallback: function(requestState) {
            },
            lastCallback: function(requestState) {
            },
            info: {
              myParameter: 'value'
            },
            important: false
          }
          
          liquidAjaxCart.add(body, options);
        },

        removeEmbossing() {
          // console.log(this.$store.global.cart);
          const embossingProduct = this.$store.global.cart.items.find(el => el.product_type === 'Addon');
          // console.log(embossingProduct);
          this.embossing.id = embossingProduct.id.toString();
          const newQuantity = embossingProduct.quantity - 1;

          const body = {
              id: this.embossing.id,
              quantity: newQuantity
          }
          
          const options = {
            firstCallback: function(requestState) {
            },
            lastCallback: function(requestState) {
            },
            info: {
              myParameter: 'value'
            },
            important: false
          }
          
          liquidAjaxCart.change(body, options);          
        },

        removeItem(id, quantity) {
          const body = {
              id: id,
              quantity: quantity
          }
          
          const options = {
            firstCallback: function(requestState) {
            },
            lastCallback: function(requestState) {
            },
            info: {
              myParameter: 'value'
            },
            important: false
          }
          
          liquidAjaxCart.change(body, options);          
        },
      
        addItem(id, quantity) {
          const body = {
            items: [
              {
                id: id,
                quantity: quantity
              }
            ] 
          }
          
          const options = {
            firstCallback: function(requestState) {
            },
            lastCallback: function(requestState) {
            },
            info: {
              myParameter: 'value'
            },
            important: false
          }
          
          liquidAjaxCart.add(body, options);          
        },

        updateCart() {
          // Request body data you want to send to Shopify
          const body = {
            attributes: {
              'wrapping': this.attributes.wrapping,
              'invoice': this.attributes.invoice,
              'vat': this.attributes.vat,
            }
          }

          const options = {
            firstCallback: function(requestState) {
            },
            lastCallback: function(requestState) {
            },
            info: {
              myParameter: 'value'
            },

            important: false
          }

          liquidAjaxCart.update(body, options);
        },

        clearCart() {
          const body = {}
          const options = {
            firstCallback: function(requestState) {
              /**
               * This callback function will be called first after the request is performed,
               * thus none of request subscribers knows the result of the request,
               * thus Cart state is not updated yet, sections are not updated yet,
               * everything is not updated yet.
               */
            },
            lastCallback: function(requestState) {
              /**
               * This callback-function will be called the latest
               * among request subscribers,
               * thus all the request subscribers are executed,
               * thus Cart state is updated, sections are updated,
               * everything is updated.
               */
            },
            info: {
              /**
               * Any additional data you want to attach to the Request state object.
               * Don't use the "initiator" and the "cancel" keys.
               */
              myParameter: 'value'
            },

            // whether the request should go to the beginning of the queue rather than to the end
            important: false
          }

          liquidAjaxCart.clear(body, options);
        },
      
        // swapProductInfo() {
        //   window[window.slayedNamespace].helpers
        //     .fetchHTML(
        //       `${this.el.dataset.url}?variant=${this.currentVariant.id}`
        //     )
        //     .then((responseHTML) => {
        //       const priceSource = responseHTML.querySelector(this.selectors.priceContainer)
        //       const priceTarget = this.el.querySelector(this.selectors.priceContainer)
        //       const mediaSource = responseHTML.querySelector(this.selectors.mediaContainer)
        //       const mediaTarget = this.el.querySelector(this.selectors.mediaContainer)
        //       const addButtonSource = responseHTML.querySelector(
        //         `${this.selectors.productForm} [name="add"]`
        //       )
        //       const addButtonTarget = this.el.querySelector(`${this.selectors.productForm} [name="add"]`)
      
        //       console.log(responseHTML)
        //       console.log(priceTarget)

        //       if (priceSource && priceTarget) {
        //         priceTarget.replaceWith(priceSource)
        //       }
      
        //       if (mediaSource && mediaTarget) {
        //         mediaTarget.replaceWith(mediaSource)
        //       }
      
        //       if (addButtonSource && addButtonTarget) {
        //         addButtonTarget.replaceWith(addButtonSource)
        //       }
      
        //     })
        // }, 
      
        getVariantData() {
          this.variantData =
            this.variantData || JSON.parse(this.el.querySelector(this.selectors.variantsJson).textContent)
          return this.variantData
        }      
      }
  }
}